import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { Image } from '../../../../components/atoms'

const ItemHouseEquipment = ({
  className,
  equipment,
}: {
  className?: string
  equipment: {
    label: string
    icon: string
  }
}) => {
  return (
    <div className={clsx(s.equipmentContent, className)}>
      <div className={s.containerIcon}>
        <Image type='contain' src={equipment.icon} alt={equipment.label} />
      </div>
      <div className={s.description}>{equipment.label}</div>
    </div>
  )
}

export default ItemHouseEquipment
